import React from "react";
import { useIntl } from "react-intl";
import {
  Container,
  Grid,
  Typography,
  Link,
  Theme,
  createStyles,
  AppBar,
  Toolbar,
  Card,
  CardContent,
  Paper,
  Box,
  useTheme,
  useMediaQuery
} from "@material-ui/core";
import Carousel from "react-material-ui-carousel";
import { makeStyles } from "@material-ui/core/styles";
import { Room, Settings, StoreMallDirectory, SupervisorAccount } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginBottom: theme.spacing(6)
    },
    appbar: {
      backgroundColor: theme.palette.pomagranatered.main,
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },
    titleText: {
      textAlign: "center",
      fontSize: "28px",
      fontWeight: 500,
      letterSpacing: "0.5px",
      color: "#404040",
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4)
    },
    cardIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "54px",
      width: "54px",
      color: theme.palette.pomagranatered.main,
      border: "solid",
      borderColor: theme.palette.pomagranatered.main,
      borderWidth: "2px",
      borderRadius: "32px"
    },
    cardText: {
      textAlign: "center",
      fontSize: "16px",
      fontWeight: "normal",
      color: "#404040"
    },
    carousel: {
      height: "100%"
    },
    carouselIndicator: {
      color: theme.palette.pomagranatered.main
    }
  })
);

interface ICardProps {
  icon: JSX.Element;
  text: string;
  isMobile: boolean;
}

function CardItem(props: ICardProps) {
  const classes = useStyles();

  return (
    <Card
      component={Paper}
      variant="outlined"
      style={{ height: props.isMobile ? "200px" : "100%" }}
    >
      <CardContent>
        <Grid container direction="column" justifyContent="center" alignItems="center" spacing={2}>
          <Grid item xs={12}>
            <Box className={classes.cardIcon}>{props.icon}</Box>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.cardText}>{props.text}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

function Header() {
  const classes = useStyles();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const CARD_ITEMS: Array<ICardProps> = [
    {
      icon: <StoreMallDirectory fontSize="large" />,
      text: intl.formatMessage({ id: "CARD_ITEM_TEXT_1" }),
      isMobile: isMobile
    },
    {
      icon: <Room fontSize="large" />,
      text: intl.formatMessage({ id: "CARD_ITEM_TEXT_2" }),
      isMobile: isMobile
    },
    {
      icon: <SupervisorAccount fontSize="large" />,
      text: intl.formatMessage({ id: "CARD_ITEM_TEXT_3" }),
      isMobile: isMobile
    },
    {
      icon: <Settings fontSize="large" />,
      text: intl.formatMessage({ id: "CARD_ITEM_TEXT_4" }),
      isMobile: isMobile
    }
  ];

  const renderCardCarousel = () => (
    <Carousel
      className={classes.carousel}
      activeIndicatorIconButtonProps={{ className: classes.carouselIndicator }}
      navButtonsAlwaysInvisible
    >
      {CARD_ITEMS.map((item, i) => (
        <CardItem {...item} key={i} />
      ))}
    </Carousel>
  );

  const renderCardGrid = () => (
    <Grid container spacing={3}>
      {CARD_ITEMS.map((item, i) => (
        <Grid key={i} item xs={3}>
          <CardItem {...item} />
        </Grid>
      ))}
    </Grid>
  );

  return (
    <div className={classes.root}>
      <AppBar className={classes.appbar} position="static">
        <Toolbar>
          <Container maxWidth="lg">
            <Grid container justifyContent="center">
              <Grid item sm={12}>
                <Link color="inherit" href="https://www.yemeksepeti.com/">
                  <img src="/y_market_horizontal_white.png" alt="" width="300"/>
                </Link>
              </Grid>
            </Grid>
          </Container>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg">
        <Typography className={classes.titleText}>
          {intl.formatMessage({ id: "FORM_TITLE" })}
        </Typography>
        {isMobile ? renderCardCarousel() : renderCardGrid()}
      </Container>
    </div>
  );
}

export default Header;
